import { type ReactNode, useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { LocaleConfigProvider } from '../modules/locale';
import { bindAuthToApiClient } from '../modules/auth/useAuth';

bindAuthToApiClient();

type Props = { children: ReactNode };

export function RootProviders({ children }: Props) {
  // useState 而不是 module-level —— 避免测试 / 多 root 共享同一 cache
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: (failureCount, error) => {
              // 401 不重试（已经被 services/api.ts 内部处理过 refresh）
              if (typeof error === 'object' && error !== null && 'status' in error) {
                const status = (error as { status: unknown }).status;
                if (status === 401 || status === 403) return false;
              }
              return failureCount < 2;
            },
            staleTime: 30_000,
          },
        },
      }),
  );

  return (
    <LocaleConfigProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>{children}</BrowserRouter>
      </QueryClientProvider>
    </LocaleConfigProvider>
  );
}
